import { Card, XStack } from '@ninjacart/nc-nk-ui';
import {AnimalsListCard}  from '@ninjacart/nc-nk-adaptive-cards';

export const ProfileAnimalCard = () => {
  return (
    <XStack>
      <Card width={'100%'} marginVertical={2} backgroundColor="$cardbackground">
        <AnimalsListCard sourcePage="Profile" />
      </Card>
    </XStack>
  );
};
